module.exports = __webpack_public_path__ + "static/media/BookReviewSketch.87aad96a.jpg";